"use strict";
import s from "underscore.string";
import React from "react";
import ReactDOM from "react-dom";
import _ from "underscore";
import FactoringCompaniesStore from "../../stores/factoring_companies_store";
import Api from "../../api/api";
import get from "../data/get";
import $ from "jquery";
import "typeahead.js";
$.fn.typeahead = $.fn.typeahead.noConflict();
var store = FactoringCompaniesStore;
function clean(name) {
  return name.toLowerCase().replace(/[& -]/g, "");
}
var factoringCompanyService = {
  searchByName: function(name) {
    return _.chain(this.filterByName(name)).map(function(factoringCompany) {
      return get.factoringCompanyOffices(factoringCompany);
    }).flatten().value().slice(0, 20);
  },
  filterByName: function(name) {
    return _.select(_.sortBy(store.items, this.carrierSort), function(x) {
      return s.startsWith(clean(x.name), clean(name));
    });
  },
  carrierSort: function(carrier) {
    return carrier.name;
  }
};
function factoringCompanyOfficeDisplay(factoringCompanyOffice) {
  get.factoringCompany(factoringCompanyOffice);
  var paymentAddress = get.paymentAddress(factoringCompanyOffice);
  var lines = [];
  lines.push(paymentAddress.name);
  lines.push(paymentAddress.address_line_1);
  if (paymentAddress.address_line_2) {
    lines.push(paymentAddress.address_line_2);
  }
  lines.push(paymentAddress.city + ", " + paymentAddress.state);
  return lines.join("<br>");
}
function restingDisplay(carrier) {
  return factoringCompanyOfficeDisplay(carrier).split("<br>").join(" - ");
}
function focused(props) {
  if (props.onFocus) {
    props.onFocus();
  }
}
export default React.createClass({
  getInitialState: function() {
    return {
      term: this.props.factoringCompanyOffice ? restingDisplay(this.props.factoringCompanyOffice) : "",
      factoringCompanyOffice: this.props.factoringCompanyOffice
    };
  },
  componentWillReceiveProps: function(newProps) {
    if (this.props.factoringCompanyOffice !== newProps.factoringCompanyOffice) {
      this.setState({
        term: newProps.factoringCompanyOffice ? restingDisplay(newProps.factoringCompanyOffice) : "",
        factoringCompanyOffice: newProps.factoringCompanyOffice
      });
    }
  },
  componentDidMount: function() {
    var component = this;
    var element = ReactDOM.findDOMNode(this);
    Api.FactoringCompanies.index().then(function() {
      $(element).typeahead(
        {
          minLength: 1,
          highlight: false
        },
        {
          name: "carrier-setter",
          displayKey: function(c) {
            return c ? restingDisplay(c) : "";
          },
          source: function(term, callback) {
            callback(factoringCompanyService.searchByName(term));
          },
          templates: {
            empty: '<div className="tt-no-matches">No matches found</div>',
            suggestion: factoringCompanyOfficeDisplay
          }
        }
      );
      var select = function(typeaheadEvent, factoringCompanyOffice) {
        component.setState({
          term: restingDisplay(factoringCompanyOffice),
          factoringCompanyOffice
        });
        component.props.onSelect(factoringCompanyOffice);
        $(element).typeahead("close");
      };
      $(element).on("typeahead:selected", select);
      $(element).on("typeahead:autocompleted", select);
      $(element).on("typeahead:closed", function(jquery, carrier) {
        if (!component.state.factoringCompanyOffice) {
          component.setState({
            term: ""
          });
          component.props.onClear();
        }
      });
    });
  },
  componentWillUnmount: function() {
    var element = ReactDOM.findDOMNode(this);
    $(element).typeahead("destroy");
  },
  updateTerm: function(changeEvent) {
    this.setState({
      term: changeEvent.target.value,
      carrier: null
    });
  },
  render: function() {
    return /* @__PURE__ */ React.createElement(
      "input",
      {
        type: "text",
        value: this.state.term,
        onChange: this.updateTerm,
        onFocus: () => focused(this.props),
        className: "carrier-setter__typeahead",
        placeholder: "Factoring Company Office"
      }
    );
  }
});
